// const BASE_URL = import.meta.env.VITE_API_BASE_URL;

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const BASE_URL = API_BASE_URL
  ? API_BASE_URL
  : "http://localhost:5121/api";

// Google reCAPTCHA v2 site key (public). Falls back to Google's official
// test key (always passes) so local development works without configuration.
export const RECAPTCHA_SITE_KEY =
  import.meta.env.VITE_RECAPTCHA_SITE_KEY ||
  "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

// declare global {
//   interface Window {
//     RUNTIME_CONFIG: {
//       API_BASE_URL: string;
//     };
//   }
// }

// const _runtimeUrl = window.RUNTIME_CONFIG?.API_BASE_URL;
// export const BASE_URL =
//   _runtimeUrl && !_runtimeUrl.startsWith("${")
//     ? _runtimeUrl
//     : "http://localhost:5121/api";
